import {AfterViewInit, Component, ElementRef, HostListener, ViewChild} from '@angular/core';
import {FooterService} from './services/footer.service';
import {Router} from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements AfterViewInit{

  constructor(public router: Router, private footerService: FooterService) { }
  public footerHeight: number;
  public innerHeight: any;
  footer;


  @ViewChild('footer', { read: ElementRef }) footerView: ElementRef ;

  @HostListener('window:resize', ['$event'])
  onResize(event): void {
    this.innerHeight = event.target.innerHeight;
    setTimeout(() => {
      this.footerHeight = this.footer.children[0].offsetHeight;
      this.footerService.setFooterHeight(this.footerHeight);
    }, 500);
  }

  ngAfterViewInit(): void {
    this.footer = this.footerView.nativeElement;
    this.footerHeight = this.footer.children[0].offsetHeight;
    this.footerService.setFooterHeight(this.footerHeight);
  }
}
